import { Theme, makeStyles } from '@focaldata/cin-ui-components'

const useStyles = makeStyles()((theme: Theme) => ({
  marginLeft: {
    marginLeft: theme.spacing(2)
  }
}))

export default useStyles
